import { render, staticRenderFns } from "./InspectorField.vue?vue&type=template&id=2af4aaae&scoped=true&"
import script from "./InspectorField.vue?vue&type=script&setup=true&lang=js&"
export * from "./InspectorField.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./InspectorField.vue?vue&type=style&index=0&id=2af4aaae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af4aaae",
  null
  
)

export default component.exports